<template>
  <div>
    <PeriodsMemberOtoCommunicationComponents
      requestUrl="/api/app/arrange/chatList/"
      publishUrl="/api/app/arrange/chatList/save/"
      deleteUrl="/api/app/arrange/chatList/delete/"
    >
      <template #base-info-left="{ info }">
        <img :src="info.teacher_avatar" class="avatar f-left" />
        <div class="info">
          <div class="name">
            <span class="name-c">{{ info.teacher_name }}</span>
          </div>
          <div class="clear time">
            <label class="f-left light">上课时间：</label>
            <span class="f-left light">{{ info.course_time }}</span>
          </div>
        </div>
      </template>
    </PeriodsMemberOtoCommunicationComponents>
  </div>
</template>
<script>
import PeriodsMemberOtoCommunicationComponents from '@/components/communication/PeriodsMemberOtoCommunication';

export default {
  name: 'PeriodsMemberOtoCommunication',
  components: {
    PeriodsMemberOtoCommunicationComponents,
  },
};
</script>
<style lang="scss" scoped>
.avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
}
.info {
  margin-left: 96px;
  padding-top: 8px;
}
.name {
  margin-bottom: 12px;
  font-size: 16px;
  color: #333333;
  font-weight: 600;
}
.time {
  font-size: 14px;
}
label {
  color: rgba(89, 89, 89, 1);
}
.light {
  color: #999999;
}
</style>
